import SectorService from '../services/Sector.js';
import Multiselect from 'vue-multiselect';
import InfiniteLoading from 'vue-infinite-loading';

if ($('#libraries-list-component').length) {
    var app = new Vue({
        el: '#libraries-list-component',
        data: {
            loading: true,
            firstLoad: true,
            sectors: [],
            sectorSlugs: [],
            libraries: [],
            page: 1,
            searchOptions: {
                sector: null,
                search: '',
            }
        },
        methods: {
            getLibraries($state) {
                let url = this.constructUrl();
                url = url + '&page=' + this.page;

                var scrollPosition = null;
                if (this.firstLoad && sessionStorage.scrollPos && sessionStorage.scrollPos != 0) {
                    scrollPosition = sessionStorage.scrollPos;
                }

                axios.get('/api/v1' + url).then((response) => {
                    if (this.page == 1 && response.data.data.length) {
                        this.libraries = response.data.data;
                        this.libraries.splice(2, 0, null);
                    } else {
                        this.libraries.push.apply(this.libraries, response.data.data)
                    }

                    this.loading = false;
                    this.page++;
                    if (this.page > response.data.last_page) {
                        $state.complete();
                    } else {
                        $state.loaded();
                    }

                    if (this.firstLoad) {
                        this.$nextTick(() => {
                            if (scrollPosition) {
                                $(window).scrollTop(scrollPosition)
                            }
                        });
                    }

                    this.firstLoad = false;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getParameter(name, url = window.location.href) {
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            getSectorName(option) {
                let value = this.sectors.filter(obj => {
                    return obj.id === option
                });

                return value[0].name;
            },
            debounceInput: _.debounce(function () {
                this.processSearch();
            }, 1000),
            constructUrl() {

                let url = '/libraries';

                if (this.searchOptions.sector) {
                    url = url + '/' + this.searchOptions.sector;
                }

                if (this.searchOptions.search) {
                    url = url + '?search=' + this.searchOptions.search;
                } else {
                    url = url + '?search=';
                }

                return url;
            },
            processSearch() {
                this.libraries = [];
                this.page = 1;
                this.firstLoad = true;
                this.loading = true;
                this.$refs.infiniteLoading.stateChanger.reset();
            }
        },
        mounted() {
            this.searchOptions.search = this.getParameter('search');

            const pathArray = window.location.pathname.split('/');
            if (pathArray[2]) {
                this.searchOptions.sector = pathArray[2];
            }
            SectorService.getSectors().then(data => {
                this.sectors = data;
                this.sectorSlugs = this.sectors.map(a => a.id);
            });

            $(window).scroll(function () {
                sessionStorage.scrollPos = $(window).scrollTop();
            });
        },
        components: {
            'multiselect': Multiselect,
            InfiniteLoading
        },
    });
}